import React from 'react';
import styled from 'styled-components';
import { SideDrawer } from '../components/shared/SideDrawer';
import { eSideDrawerContentType } from '../types/sideDrawer/eSideDrawerContentType';
import { EditConversationDrawerContainer } from '../components/conversations/EditConversationDrawerContainer';
import { useSelector } from 'react-redux';
import { RootStore } from '../store/types';
import { AccessControlRequired } from 'components/accessControl/AccessControlRequired';
import { RefreshTokenContainer } from 'components/accessControl/RefreshToken/RefreshTokenContainer';
import { ShowKeeperTheRedCard } from '../components/antiKeeper/ShowKeeperTheRedCard';
import type { FCWithChildren } from '../types/FCWithChildren';

const AppWrapperGrid = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  grid-template-areas: 'side-drawer main';
`;

const Main = styled.div`
  grid-area: main;
`;
export const AppWrapper: FCWithChildren = ({ children }) => {
  const { contentType } = useSelector((state: RootStore) => state.sideDrawer);

  return (
    <ShowKeeperTheRedCard>
      <RefreshTokenContainer />
      <AccessControlRequired>
        <AppWrapperGrid>
          <Main>{children}</Main>
          <SideDrawer>
            {contentType === eSideDrawerContentType.Conversation && <EditConversationDrawerContainer />}
          </SideDrawer>
        </AppWrapperGrid>
      </AccessControlRequired>
    </ShowKeeperTheRedCard>
  );
};
